export const wattageKeywords = {
	"300-watt-solar-panels": "300,399",
	"400-watt-solar-panels": "400,499",
	"500-watt-solar-panels": "500, 599",
	"600-watt-solar-panels": "600",
};

export const traderAllIndexUrl = "/trader/deals";
